import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupIcinga2Group } from "./icinga-two";

const Icinga2SetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const Icinga2SetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Fresh section per catalog build - see network/section.ts for the rationale.
export const icinga2Scanners = (): Section => {
  const icinga2Scanners = new Section("icinga_scanner", [
    new Translation("en", "Icinga2 Scanners"),
    new Translation("en", "Icinga2-Scanner"),
  ]);
  icinga2Scanners.help = [
    new Translation(
      "en",
      `Add Icinga2 to get more detailed information about their API!`
    ),
    new Translation(
      "de",
      `Fügen Sie Icinga2 hinzu, um detailliertere Informationen über deren API zu erhalten!`
    ),
  ];

  icinga2Scanners.description = [
    new Translation("en", Icinga2SetupEn),
    new Translation("de", Icinga2SetupDe),
  ];

  setupIcinga2Group(icinga2Scanners, 0);
  return icinga2Scanners;
};
